import type { IconProps } from '../types/IconProps.ts';
export const ArrowLeftToLine: IconProps = {
    name: 'ArrowLeftToLine',
    children: [
        `<path d="m13 6-5.87 5.8c-.17.1-.17.29 0 .4L13 18M9 12h12M3 5v14" />`,
    ]
};